import {ImageLine} from '@dropbox/dig-icons/assets';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {snackbarAtom} from 'atoms/snackbar';
import {ACCEPTABLE_FILE_TYPES, handleFiles} from 'components/DSYS/editor/nodes/fileUploadUtil';
import {
  RICH_TEXT_MEDIA_UPLOAD_SIZE_LIMIT_BYTES,
  useRichTextMediaUpload,
} from 'components/DSYS/editor/plugins/MediaUploadContext';
import {t} from 'i18next';
import {useSetAtom} from 'jotai';
import {useCallback, useRef} from 'react';

import {ToolbarButton} from './ToolbarButton';

export const ImageToolbarButton = () => {
  const [editor] = useLexicalComposerContext();
  const mediaUpload = useRichTextMediaUpload();
  const maxFileSizeBytes = mediaUpload.maxFileSizeBytes ?? RICH_TEXT_MEDIA_UPLOAD_SIZE_LIMIT_BYTES;
  const fileInputRef = useRef<HTMLInputElement>(null);
  const setSnackbarMessage = useSetAtom(snackbarAtom);

  const handleFileChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!event.target.files) {
        return;
      }

      const validFiles = Array.from(event.target.files).filter(
        (file) => file.size <= maxFileSizeBytes
      );

      if (validFiles.length !== event.target.files.length) {
        setSnackbarMessage({
          text: t('rich_text_upload_size_error'),
        });
      }

      handleFiles([...validFiles], mediaUpload, editor);
      // Reset file input
      if (event.target) {
        // eslint-disable-next-line no-param-reassign
        event.target.value = '';
      }
    },
    [editor, maxFileSizeBytes, mediaUpload, setSnackbarMessage]
  );

  const handleInsertImage = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  return (
    <>
      <ToolbarButton
        title="Insert image"
        onClick={handleInsertImage}
        icon={ImageLine}
        keycaps={['Command', 'Shift', 'I']}
      />
      <input
        type="file"
        ref={fileInputRef}
        style={{display: 'none'}}
        accept={ACCEPTABLE_FILE_TYPES.join(',')}
        onChange={handleFileChange}
      />
    </>
  );
};
